//Fichier servant à définir les variables de configuration pour l'application

const settings = {
    // Définit le nombre d'événements de pointage à afficher dans la carte du dashboard
    nbPointageEventDisplayed: parseInt(localStorage.getItem('nbPointageEventDisplayed')) || 5,
    nbPointageHistoryDisplayed: parseInt(localStorage.getItem('nbPointageHistoryDisplayed')) || 6,
};

export default settings;